import Navbar from '@/components/layout/Navbar';
import { PricingCardsGrid } from '@/components/pricing';

const ManagePlan = () => {
  return (
    <div className="min-h-screen w-full flex flex-col bg-background">
      <Navbar />
      <main className="flex-grow py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-2xl font-bold mb-6">Manage Your Plan</h1>
          <PricingCardsGrid />
        </div>
      </main>
    </div>
  );
};

export default ManagePlan;
